import http, { expandURI } from '@/utils/ajax'
import { TTY_ACCT_INIT_LOADING, TTY_ACCT_INIT_SUCCESS, TTY_ACCT_INIT_FAIL, TTY_MASTER_INIT_LOADING, TTY_MASTER_INIT_SUCCESS, TTY_MASTER_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async ttyAcctInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.treatyAcctManagement
    if (apiUrl) {
      commit(TTY_ACCT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(TTY_ACCT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(TTY_ACCT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(TTY_ACCT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async treatyMasterInit({ commit, state }) {
    const apiUrl = state.menu.treatyMasterInit
    if (apiUrl) {
      commit(TTY_MASTER_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(TTY_MASTER_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(TTY_MASTER_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(TTY_MASTER_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
